module.exports = __webpack_public_path__ + "img/become_vip@3x.9edaa98f.png";